import React from 'react'
import { Row, Col, Card, Space, Statistic, Button, Typography, Progress, Tag } from 'antd'
import { ExperimentOutlined, ClockCircleOutlined } from '@ant-design/icons'
import { formatDateTime, getTheatreStatusBadge, getElapsedTime } from '../../utils/formatters'

const { Text } = Typography

const TheatreStatusTab = ({ activeTheatres }) => {
  return (
    <Row gutter={[16, 16]}>
      {activeTheatres.map((theatre) => (
        <Col xs={24} md={12} key={theatre.theatreId}>
          <Card
            title={
              <Space>
                <ExperimentOutlined />
                <span>{theatre.theatreName}</span>
                {getTheatreStatusBadge(theatre.status)}
              </Space>
            }
            extra={
              <Button size='small' type='primary'>
                Details
              </Button>
            }
          >
            {theatre.status === 'Active' ? (
              <div>
                <Statistic
                  title='Current Procedure:'
                  value={theatre.currentProcedure}
                  valueStyle={{ fontSize: '18px' }}
                />
                <Row gutter={16} style={{ marginTop: '16px' }}>
                  <Col span={12}>
                    <div style={{ marginBottom: '8px' }}>
                      <Text type='secondary'>Started:</Text>{' '}
                      <Text strong>{formatDateTime(theatre.startTime).split(' ')[1]}</Text>
                      <div>
                        <Text type='secondary'>{getElapsedTime(theatre.startTime)}</Text>
                      </div>
                    </div>
                    <div style={{ marginBottom: '8px' }}>
                      <Text type='secondary'>Patient:</Text>{' '}
                      <Text strong>
                        {theatre.patient.split(' ')[0]} {theatre.patient.split(' ')[1]}
                      </Text>
                      {theatre.patient.includes('PT-') && (
                        <div style={{ marginTop: '2px' }}>
                          <Tag style={{ fontSize: '11px', padding: '0 4px' }}>
                            {theatre.patient.match(/\(([^)]+)\)/)[1]}
                          </Tag>
                        </div>
                      )}
                    </div>
                    <div>
                      <Text type='secondary'>Surgeon:</Text> <Text strong>{theatre.surgeon}</Text>
                    </div>
                  </Col>
                </Row>

                {/* Progress bar showing surgery progress */}
                {theatre.startTime && theatre.estimatedEndTime && (
                  <div style={{ marginTop: '16px' }}>
                    <Progress percent={100} showInfo={false} strokeColor='red' size='small' status='active' />
                    <Space
                      style={{ display: 'flex', justifyContent: 'space-between', marginTop: '2px', fontSize: '12px' }}
                    >
                      <Text type='secondary'>
                        {getElapsedTime(theatre.startTime)} / {getElapsedTime(theatre.startTime)}
                      </Text>
                      <Text type='secondary'>0m remaining</Text>
                    </Space>
                  </div>
                )}
              </div>
            ) : (
              <div style={{ textAlign: 'center', padding: '16px' }}>
                <Text type='secondary'>No active procedure</Text>
              </div>
            )}

            <div style={{ marginTop: '16px', borderTop: '1px solid #f0f0f0', paddingTop: '16px' }}>
              <Text type='secondary'>Next Scheduled Procedure</Text>
              <div style={{ marginTop: '8px' }}>
                <Space direction='vertical' size={2}>
                  <Text strong>{theatre.nextProcedure}</Text>
                  <Space align='start'>
                    <Text type='secondary'>Patient:</Text>{' '}
                    <div>
                      <Text>{theatre.nextPatient.split(' (')[0]}</Text>
                      {theatre.nextPatient.includes('PT-') && (
                        <div>
                          <Tag style={{ fontSize: '11px', padding: '0 4px' }}>
                            {theatre.nextPatient.match(/\(([^)]+)\)/)[1]}
                          </Tag>
                        </div>
                      )}
                    </div>
                  </Space>
                  <Space>
                    <ClockCircleOutlined />
                    <Text>Scheduled: {formatDateTime(theatre.nextStartTime).split(' ')[1]}</Text>
                  </Space>
                </Space>
              </div>
            </div>
          </Card>
        </Col>
      ))}
    </Row>
  )
}

export default TheatreStatusTab
